"use client";
import styles from "./styles.module.scss";
import prevArrow from "../../../assets/images/prev.svg";
import nextArrow from "../../../assets/images/next.svg";
import {
  FC,
  ForwardedRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import classNames from "classnames";

export interface ArrowNavigationProps {
  direction: "left" | "right";
  className?: string;
  disabled?: boolean;
}

// export const ArrowNavigation: FC<ArrowNavigationProps> = ({
//   direction = "left",
// }) => {
//   const refEl = useRef<HTMLDivElement>(null);

//   const getElWidth = () => {
//     return refEl.current?.clientWidth || 0;
//   };

//   const handleHover = () => {
//     if (refEl.current) {
//       refEl.current.style.transition = `background-position 0.5s`;

//       if (direction === "left") {
//         refEl.current.style.backgroundPosition = `-${getElWidth()}px 0px, 0px 0px`;
//       } else {
//         refEl.current.style.backgroundPosition = `${getElWidth()}px 0px, 0px 0px`;
//       }
//     }
//   };

//   const handleOut = () => {
//     if (refEl.current) {
//       refEl.current.style.transition = `background-position 0.5s`;

//       if (direction === "left") {
//         refEl.current.style.backgroundPosition = `0px 0px, ${getElWidth()}px 0px`;
//       } else {
//         refEl.current.style.backgroundPosition = `0px 0px, -${getElWidth()}px 0px`;
//       }
//     }
//   };

//   useEffect(() => {
//     if (refEl.current) {
//       if (direction === "left") {
//         refEl.current.style.backgroundPosition = `0px 0px, ${getElWidth()}px 0px`;
//       } else {
//         refEl.current.style.backgroundPosition = `0px 0px, -${getElWidth()}px 0px`;
//       }
//     }
//   }, [direction]);

//   return (
//     <div
//       onMouseOver={handleHover}
//       onMouseOut={handleOut}
//       ref={refEl}
//       style={{
//         WebkitMaskImage: `url(${
//           direction === "left" ? prevArrow.src : nextArrow.src
//         })`,
//         maskImage: `url(${
//           direction === "left" ? prevArrow.src : nextArrow.src
//         })`,
//       }}
//       className={classNames(
//         styles.arrow_navigation,
//         {
//           [styles.left_arrow]: direction === "left",
//         },
//         { [styles.right_arrow]: direction === "right" }
//       )}
//     />
//   );
// };

export interface ArrowNavigationRef {
  onMouseOver: () => void;
  onMouseOut: () => void;
}

// eslint-disable-next-line react/display-name
export const ArrowNavigation = forwardRef(
  (
    { direction = "left", disabled }: ArrowNavigationProps,
    ref: ForwardedRef<ArrowNavigationRef>
  ) => {
    useImperativeHandle(ref, () => ({
      onMouseOut: () => {
        handleOut();
      },
      onMouseOver: () => {
        handleHover();
      },
    }));

    const refEl = useRef<HTMLDivElement>(null);

    const getElWidth = () => {
      return refEl.current?.clientWidth || 0;
    };

    const handleHover = () => {
      if (refEl.current && !disabled) {
        refEl.current.style.transition = `background-position 0.5s`;

        if (direction === "left") {
          refEl.current.style.backgroundPosition = `-${getElWidth()}px 0px, 0px 0px`;
        } else {
          refEl.current.style.backgroundPosition = `${getElWidth()}px 0px, 0px 0px`;
        }
      }
    };

    const handleOut = () => {
      if (refEl.current) {
        refEl.current.style.transition = `background-position 0.5s`;

        if (direction === "left") {
          refEl.current.style.backgroundPosition = `0px 0px, ${getElWidth()}px 0px`;
        } else {
          refEl.current.style.backgroundPosition = `0px 0px, -${getElWidth()}px 0px`;
        }
      }
    };

    useEffect(() => {
      if (refEl.current) {
        if (direction === "left") {
          refEl.current.style.backgroundPosition = `0px 0px, ${getElWidth()}px 0px`;
        } else {
          refEl.current.style.backgroundPosition = `0px 0px, -${getElWidth()}px 0px`;
        }
      }
    }, [direction]);

    return (
      <div
        onMouseOver={handleHover}
        onMouseOut={handleOut}
        ref={refEl}
        style={{
          WebkitMaskImage: `url(${
            direction === "left" ? prevArrow.src : nextArrow.src
          })`,
          maskImage: `url(${
            direction === "left" ? prevArrow.src : nextArrow.src
          })`,
        }}
        className={classNames(
          styles.arrow_navigation,
          {
            [styles.left_arrow]: direction === "left",
          },
          { [styles.right_arrow]: direction === "right" }
        )}
      />
    );
  }
);
